__turbopack_context__.v({
  "animation": "research-visuals-module__DNkp0q__animation",
  "converging": "research-visuals-module__DNkp0q__converging",
  "gatherInner": "research-visuals-module__DNkp0q__gatherInner",
  "gatherOuter": "research-visuals-module__DNkp0q__gatherOuter",
  "heroVisual": "research-visuals-module__DNkp0q__heroVisual",
  "motionButton": "research-visuals-module__DNkp0q__motionButton",
  "note": "research-visuals-module__DNkp0q__note",
  "orbit": "research-visuals-module__DNkp0q__orbit",
  "panel": "research-visuals-module__DNkp0q__panel",
  "particle": "research-visuals-module__DNkp0q__particle",
  "sourceStrip": "research-visuals-module__DNkp0q__sourceStrip",
  "stackBoundary": "research-visuals-module__DNkp0q__stackBoundary",
  "stackConnector": "research-visuals-module__DNkp0q__stackConnector",
  "stackFooter": "research-visuals-module__DNkp0q__stackFooter",
  "stackHeader": "research-visuals-module__DNkp0q__stackHeader",
  "stackRow": "research-visuals-module__DNkp0q__stackRow",
  "statusBadge": "research-visuals-module__DNkp0q__statusBadge",
});
